var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img",attrs:{"src":require(("@/assets/img/infograms/audit_" + _vm.currentLang + ".png")),"alt":"#"}})}
var staticRenderFns = []

export { render, staticRenderFns }